import { Progress, Tooltip, theme } from "antd";
import Link from "next/link";
import { useApplicationContext } from "src/hooks/useApplication";

interface TrialProgressBarProps {
  orgId?: string;
}

export function TrialProgressBar({ orgId }: TrialProgressBarProps) {
  const { token } = theme.useToken();
  const { subscription } = useApplicationContext();

  if (!subscription || subscription.status !== "trialing") {
    return null;
  }

  const startDate = new Date(subscription.startDate);
  const endDate = new Date(subscription.trialEndDate);
  const now = new Date();

  // Check if trial has expired
  if (now > endDate) {
    return (
      <div style={{ padding: "8px 16px", marginBottom: 8 }}>
        <div
          style={{
            fontSize: 12,
            color: token.colorError,
          }}
        >
          Trial has expired.{" "}
          <Link
            href={`/${orgId}/settings/subscriptions`}
            style={{ color: token.colorTextLightSolid }}
          >
            Upgrade
          </Link>
        </div>
      </div>
    );
  }

  const totalDays = 14; // Trial is 14 days
  const daysLeft = Math.ceil(
    (endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  );
  const daysUsed = totalDays - daysLeft;
  const percent = Math.round((daysUsed / totalDays) * 100);

  return (
    <div style={{ padding: "8px 16px", marginBottom: 8 }}>
      <Tooltip
        title={`${daysLeft} days left in trial`}
        placement="right"
        mouseEnterDelay={0.5}
      >
        <div
          style={{
            marginBottom: 4,
            fontSize: 12,
            color: token.colorTextLightSolid,
          }}
        >
          {`${daysLeft} days left in trial. `}
          <Link
            href={`/${orgId}/settings/subscriptions`}
            style={{ color: token.colorTextLightSolid }}
          >
            Upgrade
          </Link>
        </div>
        <Progress
          percent={percent}
          showInfo={false}
          size="small"
          status={daysLeft <= 3 ? "exception" : "active"}
          strokeColor={daysLeft <= 3 ? token.colorError : token.colorSuccess}
          trailColor="rgba(255, 255, 255, 0.1)"
        />
      </Tooltip>
    </div>
  );
}
